import styled from 'styled-components';
import { ModalSessionChangeStyled } from '../../ModalSessionChangeStyled';
import { rem } from 'polished';

export const ModalSessionChangeStyledOV = styled(ModalSessionChangeStyled)`
    
`;
